import {useMutation, useQueryClient} from 'react-query';
import {toast} from 'react-toastify';
import {
  IPostTerminateAgreement,
  postTerminateAgreement,
} from './postTerminateAgreement';

interface UsePostTerminateAgreementPayload extends IPostTerminateAgreement {
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

const usePostTerminateAgreement = (
  payload: UsePostTerminateAgreementPayload,
) => {
  const queryClient = useQueryClient();

  const {mutate, isLoading, error, data} = useMutation({
    mutationFn: () =>
      postTerminateAgreement({
        guid: payload.guid,
        termination_reason: payload.termination_reason,
      }),
    onSuccess: () => {
      // Invalidate both cooperation agreement queries
      queryClient.invalidateQueries(['get-cooperation-agreement-data']);
      queryClient.invalidateQueries(['get-cooperation-agreement-status']);
      queryClient.invalidateQueries(['get-cooperation-agreement-date']);

      payload.onSuccess?.();
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.messages?.[0] ||
        error?.response?.data?.message ||
        error?.message ||
        'خطا در ثبت درخواست فسخ قرارداد';

      toast.error(errorMessage, {
        position: 'bottom-right',
      });

      payload.onError?.(error);
    },
  });

  return {mutate, isLoading, error, data};
};

export default usePostTerminateAgreement;
